import './foxtown/style';
import FormStructure from './foxtown/form_structure';

export default FormStructure;